module.exports = __webpack_public_path__ + "img/photo-6-1.40a544b5.webp";